import React, { useEffect, Fragment, useState } from "react";
import { connect } from "react-redux";
import { Link, NavLink, useNavigate } from "react-router-dom";
import swal from "sweetalert";
import AdminUserService from "../../API/Services/AdminService/AdminUserService";
import FloatingSupport from "../components/FloatingSupport/FloatingSupport";
import logo from "../../images/logo/hrb-logo.png";
import LogoWhite from "../../images/logo/logofull-white.png";
import bg6 from "../../images/background/bg6.jpg";
import { Modal, Button, Form } from 'react-bootstrap';
import { FiEye, FiEyeOff } from "react-icons/fi";
import { getSubscriptionDataTypes, safeJsonParse } from "../../utils/subscriptionAccess";
import AdminSubscriberService from "../../API/Services/AdminService/AdminSubscriberService";

function Login(props) {
  const [heartActive, setHeartActive] = useState(true);
  const navigate = useNavigate();
  const [email, setEmail] = useState(() => localStorage.getItem('rememberEmail') || '');
  const [emailSend, setSendEmail] = useState("");
  const [emailCorrect, setEmailCorrect] = useState(false);
  let errorsObj = { email: "", password: "", terms_accept: false };
  const [errors, setErrors] = useState(errorsObj);
  const [password, setPassword] = useState(() => localStorage.getItem('rememberPassword') || '');
  const [rememberMe, setRememberMe] = useState(() =>
    !!(localStorage.getItem('rememberEmail') && localStorage.getItem('rememberPassword'))
  );
  var d = new Date();
  const [forgotModelShow, setForgotModelShow] = useState(false);
  const [termsModelShow, setTermsModelShow] = useState(false);
  const [termsSelected, setTermsSelected] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("usertoken")) {
      navigate("/dashboard");
    } else {
      navigate("/");
      localStorage.clear();
    }
  }, []);


  const handleRememberMeChange = () => {
    setRememberMe((prevValue) => !prevValue); // Toggle the remember me value
  };

  const handleTermsandConditionsChange = () => {
    setTermsSelected((prevValue) => !prevValue); // Toggle the remember me value
  };

  const onLogin = async (e) => {
    e.preventDefault();
    localStorage.clear();
    if (rememberMe) {
      localStorage.setItem('rememberEmail', email);
      localStorage.setItem('rememberPassword', password);
    } else {
      localStorage.removeItem('rememberEmail');
      localStorage.removeItem('rememberPassword');
    }
    let error = false;
    const errorObj = { ...errorsObj };
    if (email === "") {
      errorObj.email = "Email is required";
      error = true;
    }
    if (password === "") {
      errorObj.password = "Password is required";
      error = true;
    }
    if (!termsSelected) {
      errorObj.terms_accept = "Please accept the Terms & conditions first";
      error = true;
    }
    setErrors(errorObj);
    if (error) {
      return;
    } else {
      try {
        const data = await AdminUserService.login(email, password, rememberMe).json();
        localStorage.setItem("user", JSON.stringify(data));
        localStorage.setItem("usertoken", JSON.stringify(data.idToken));
        localStorage.setItem("is_subscribed", JSON.stringify(data.is_subscribed));
        localStorage.setItem("new_user", JSON.stringify(data.new_user));
        localStorage.setItem("subscription_end_at", JSON.stringify(data.subscription_end_at));
        localStorage.setItem("subscription_data_types", JSON.stringify(getSubscriptionDataTypes(data?.data_types || data)));
        localStorage.setItem("subscription_plan", JSON.stringify(data?.data_types?.plan));

        if (Number(data.is_subscribed) !== 1) {
          try {
            const subRes = await AdminSubscriberService.getSubscriberList({ search: email }).json();
            if (subRes?.status === true && Array.isArray(subRes.data) && subRes.data.length > 0) {
              const matchedSub = subRes.data.find(sub => {
                const emailMatch = String(sub.user_email || "").toLowerCase() === email.toLowerCase() ||
                  (Array.isArray(sub.user) && sub.user.some(u => String(u.email || "").toLowerCase() === email.toLowerCase()));
                const expiry = sub.subscription_end_at || sub.subscription_cancelled_at;
                const notExpired = expiry && new Date(expiry).getTime() > Date.now();
                const isPaid = String(sub.payment_status || "").toLowerCase() === "paid";
                return emailMatch && notExpired && isPaid;
              });

              if (matchedSub) {
                const expiry = matchedSub.subscription_end_at || matchedSub.subscription_cancelled_at;
                const dataTypes = getSubscriptionDataTypes(matchedSub.data_types || []);
                data.is_subscribed = 1;
                data.subscription_end_at = expiry;
                data.data_types = matchedSub.data_types;
                localStorage.setItem("user", JSON.stringify(data));
                localStorage.setItem("is_subscribed", JSON.stringify(1));
                localStorage.setItem("subscriptionActivePlan", true);
                localStorage.setItem("subscription_end_at", JSON.stringify(expiry));
                localStorage.setItem("subscription_data_types", JSON.stringify(dataTypes));
                localStorage.setItem("cancellation_requested_at", JSON.stringify(matchedSub.cancellation_requested_at || matchedSub.subscription_start_at));
              }
            }
          } catch (e) {
            console.error("Login fallback subscriber check error", e);
          }
        }

        const user = JSON.parse(localStorage.getItem("user"));
        const NewUser = JSON.parse(localStorage.getItem("new_user"));

        if (user != "") {
          const userRole = JSON.parse(localStorage.getItem("user")).role;
          if (!userRole) {
            alert(user.message);
            return;
          }

          // Weekly Data
          localStorage.removeItem('enddate');
          localStorage.removeItem('builderId');

          // Builder
          localStorage.removeItem("selectedBuilderNameByFilterBuilder");
          localStorage.removeItem("selectedStatusByBuilderFilterBuilder");
          localStorage.removeItem("selectedCompanyTypeByFilterBuilder");
          localStorage.removeItem("builder_name_Builder");
          localStorage.removeItem("is_active_Builder");
          localStorage.removeItem("active_communities_Builder");
          localStorage.removeItem("company_type_Builder");
          localStorage.removeItem("searchQueryByBuilderFilter_Builder");
          localStorage.removeItem("setBuilderFilter");

          // Subdivision
          localStorage.removeItem("selectedStatusBySubdivisionFilter_Subdivision");
          localStorage.removeItem("selectedReportingByFilter_Subdivision");
          localStorage.removeItem("selectedBuilderNameByFilter_Subdivision");
          localStorage.removeItem("productTypeStatusByFilter_Subdivision");
          localStorage.removeItem("selectedAreaByFilter_Subdivision");
          localStorage.removeItem("selectedMasterPlanByFilter_Subdivision");
          localStorage.removeItem("selectedAgeByFilter_Subdivision");
          localStorage.removeItem("selectedSingleByFilter_Subdivision");
          localStorage.removeItem("selectedGatedByFilter_Subdivision");
          localStorage.removeItem("selectedJurisdicitionByFilter_Subdivision");
          localStorage.removeItem("seletctedGasProviderByFilter_Subdivision");
          localStorage.removeItem("subdivision_status_Subdivision");
          localStorage.removeItem("reporting_Subdivision");
          localStorage.removeItem("subdivision_name_Subdivision");
          localStorage.removeItem("builder_name_Subdivision");
          localStorage.removeItem("product_type_Subdivision");
          localStorage.removeItem("area_Subdivision");
          localStorage.removeItem("masterplan_id_Subdivision");
          localStorage.removeItem("zipcode_Subdivision");
          localStorage.removeItem("lotwidth_Subdivision");
          localStorage.removeItem("lotsize_Subdivision");
          localStorage.removeItem("age_Subdivision");
          localStorage.removeItem("single_Subdivision");
          localStorage.removeItem("gated_Subdivision");
          localStorage.removeItem("juridiction_Subdivision");
          localStorage.removeItem("gasprovider_Subdivision");
          localStorage.removeItem("from_Subdivision");
          localStorage.removeItem("to_Subdivision");
          localStorage.removeItem("searchQueryBySubdivisionFilter_Subdivision");
          localStorage.removeItem("setSubdivisionFilter");

          // Product
          localStorage.removeItem("selectedStatusByProductFilter_Product");
          localStorage.removeItem("selectedBuilderNameByFilter_Product");
          localStorage.removeItem("selectedSubdivisionNameByFilter_Product");
          localStorage.removeItem("selectedAgeByFilter_Product");
          localStorage.removeItem("selectedSingleByFilter_Product");
          localStorage.removeItem("product_status_Product");
          localStorage.removeItem("builder_name_Product");
          localStorage.removeItem("subdivision_name_Product");
          localStorage.removeItem("product_name_Product");
          localStorage.removeItem("sqft_Product");
          localStorage.removeItem("stories_Product");
          localStorage.removeItem("bedroom_Product");
          localStorage.removeItem("bathroom_Product");
          localStorage.removeItem("garage_Product");
          localStorage.removeItem("current_base_price_Product");
          localStorage.removeItem("product_type_Product");
          localStorage.removeItem("area_Product");
          localStorage.removeItem("masterplan_id_Product");
          localStorage.removeItem("zipcode_Product");
          localStorage.removeItem("lotwidth_Product");
          localStorage.removeItem("lotsize_Product");
          localStorage.removeItem("age_Product");
          localStorage.removeItem("single_Product");
          localStorage.removeItem("searchQueryByProductFilter_Product");
          localStorage.removeItem("setProductFilter");

          // Permit
          localStorage.removeItem("selectedBuilderNameByFilter_Permit");
          localStorage.removeItem("selectedSubdivisionNameByFilter_Permit");
          localStorage.removeItem("productTypeStatusByFilter_Permit");
          localStorage.removeItem("selectedAreaByFilter_Permit");
          localStorage.removeItem("selectedMasterPlanByFilter_Permit");
          localStorage.removeItem("selectedAgeByFilter_Permit");
          localStorage.removeItem("selectedSingleByFilter_Permit");
          localStorage.removeItem("from_Permit");
          localStorage.removeItem("to_Permit");
          localStorage.removeItem("builder_name_Permit");
          localStorage.removeItem("subdivision_name_Permit");
          localStorage.removeItem("address2_Permit");
          localStorage.removeItem("address1_Permit");
          localStorage.removeItem("parcel_Permit");
          localStorage.removeItem("sqft_Permit");
          localStorage.removeItem("lotnumber_Permit");
          localStorage.removeItem("permitnumber_Permit");
          localStorage.removeItem("plan_Permit");
          localStorage.removeItem("product_type_Permit");
          localStorage.removeItem("area_Permit");
          localStorage.removeItem("masterplan_id_Permit");
          localStorage.removeItem("zipcode_Permit");
          localStorage.removeItem("lotwidth_Permit");
          localStorage.removeItem("lotsize_Permit");
          localStorage.removeItem("age_Permit");
          localStorage.removeItem("single_Permit");
          localStorage.removeItem("searchQueryByPermitsFilter");
          localStorage.removeItem("setPermitFilter");

          // Weekly Traffic & Sales
          localStorage.removeItem("selectedBuilderNameByFilter_TrafficSale");
          localStorage.removeItem("selectedSubdivisionNameByFilter_TrafficSale");
          localStorage.removeItem("productTypeStatusByFilter_TrafficSale");
          localStorage.removeItem("selectedAreaByFilter_TrafficSale");
          localStorage.removeItem("selectedMasterPlanByFilter_TrafficSale");
          localStorage.removeItem("selectedAgeByFilter_TrafficSale");
          localStorage.removeItem("selectedSingleByFilter_TrafficSale");
          localStorage.removeItem("from_TrafficSale");
          localStorage.removeItem("to_TrafficSale");
          localStorage.removeItem("builder_name_TrafficSale");
          localStorage.removeItem("subdivision_name_TrafficSale");
          localStorage.removeItem("weeklytraffic_TrafficSale");
          localStorage.removeItem("cancelations_TrafficSale");
          localStorage.removeItem("netsales_TrafficSale");
          localStorage.removeItem("totallots_TrafficSale");
          localStorage.removeItem("lotreleased_TrafficSale");
          localStorage.removeItem("unsoldinventory_TrafficSale");
          localStorage.removeItem("product_type_TrafficSale");
          localStorage.removeItem("area_TrafficSale");
          localStorage.removeItem("masterplan_id_TrafficSale");
          localStorage.removeItem("zipcode_TrafficSale");
          localStorage.removeItem("lotwidth_TrafficSale");
          localStorage.removeItem("lotsize_TrafficSale");
          localStorage.removeItem("zoning_TrafficSale");
          localStorage.removeItem("age_TrafficSale");
          localStorage.removeItem("single_TrafficSale");
          localStorage.removeItem("searchQueryByWeeklyTrafficFilter");
          localStorage.removeItem("setTrafficFilter");

          // Base Price
          localStorage.removeItem("selectedBuilderNameByFilter_BasePrice");
          localStorage.removeItem("selectedSubdivisionNameByFilter_BasePrice");
          localStorage.removeItem("productTypeStatusByFilter_BasePrice");
          localStorage.removeItem("selectedAreaByFilter_BasePrice");
          localStorage.removeItem("selectedMasterPlanByFilter_BasePrice");
          localStorage.removeItem("selectedAgeByFilter_BasePrice");
          localStorage.removeItem("selectedSingleByFilter_BasePrice");
          localStorage.removeItem("selectedStatusBySubdivisionFilter_BasePrice");
          localStorage.removeItem("selectedStatusByProductFilter_BasePrice");
          localStorage.removeItem("from_BasePrice");
          localStorage.removeItem("to_BasePrice");
          localStorage.removeItem("builder_name_BasePrice");
          localStorage.removeItem("subdivision_name_BasePrice");
          localStorage.removeItem("product_name_BasePrice");
          localStorage.removeItem("sqft_BasePrice");
          localStorage.removeItem("stories_BasePrice");
          localStorage.removeItem("bedroom_BasePrice");
          localStorage.removeItem("bathroom_BasePrice");
          localStorage.removeItem("garage_BasePrice");
          localStorage.removeItem("baseprice_BasePrice");
          localStorage.removeItem("product_type_BasePrice");
          localStorage.removeItem("area_BasePrice");
          localStorage.removeItem("masterplan_id_BasePrice");
          localStorage.removeItem("zipcode_BasePrice");
          localStorage.removeItem("lotwidth_BasePrice");
          localStorage.removeItem("lotsize_BasePrice");
          localStorage.removeItem("age_BasePrice");
          localStorage.removeItem("single_BasePrice");
          localStorage.removeItem("product_status_BasePrice");
          localStorage.removeItem("subdivision_status_BasePrice");
          localStorage.removeItem("searchQueryByBasePricesFilter");
          localStorage.removeItem("setBasePriceFilter");

          // Closing
          localStorage.removeItem("seletctedClosingTypeByFilter_Closing");
          localStorage.removeItem("selectedBuilderNameByFilter_Closing");
          localStorage.removeItem("selectedSubdivisionNameByFilter_Closing");
          localStorage.removeItem("seletctedLenderByFilter_Closing");
          localStorage.removeItem("productTypeStatusByFilter_Closing");
          localStorage.removeItem("selectedAreaByFilter_Closing");
          localStorage.removeItem("selectedMasterPlanByFilter_Closing");
          localStorage.removeItem("selectedAgeByFilter_Closing");
          localStorage.removeItem("selectedSingleByFilter_Closing");
          localStorage.removeItem("from_Closing");
          localStorage.removeItem("to_Closing");
          localStorage.removeItem("closing_type_Closing");
          localStorage.removeItem("document_Closing");
          localStorage.removeItem("builder_name_Closing");
          localStorage.removeItem("subdivision_name_Closing");
          localStorage.removeItem("closingprice_Closing");
          localStorage.removeItem("address_Closing");
          localStorage.removeItem("parcel_Closing");
          localStorage.removeItem("sellerleagal_Closing");
          localStorage.removeItem("buyer_Closing");
          localStorage.removeItem("lender_name_Closing");
          localStorage.removeItem("loanamount_Closing");
          localStorage.removeItem("product_type_Closing");
          localStorage.removeItem("area_Closing");
          localStorage.removeItem("masterplan_id_Closing");
          localStorage.removeItem("zipcode_Closing");
          localStorage.removeItem("lotwidth_Closing");
          localStorage.removeItem("lotsize_Closing");
          localStorage.removeItem("age_Closing");
          localStorage.removeItem("single_Closing");
          localStorage.removeItem("searchQueryByClosingsFilter");
          localStorage.removeItem("setClosingFilter");

          // Land Sale
          localStorage.removeItem("selectedBuilderNameByFilter_LandSale");
          localStorage.removeItem("selectedSubdivisionNameByFilter_LandSale");
          localStorage.removeItem("from_LandSale");
          localStorage.removeItem("to_LandSale");
          localStorage.removeItem("builder_name_LandSale");
          localStorage.removeItem("subdivision_name_LandSale");
          localStorage.removeItem("seller_LandSale");
          localStorage.removeItem("buyer_LandSale");
          localStorage.removeItem("location_LandSale");
          localStorage.removeItem("notes_LandSale");
          localStorage.removeItem("price_LandSale");
          localStorage.removeItem("priceperunit_LandSale");
          localStorage.removeItem("parcel_LandSale");
          localStorage.removeItem("document_LandSale");
          localStorage.removeItem("noofunit_LandSale");
          localStorage.removeItem("typeofunit_LandSale");
          localStorage.removeItem("searchQueryByLandSalesFilter");
          localStorage.removeItem("setLansSaleFilter");
          
          if (userRole == "Admin" || userRole == "Staff" || userRole == "Tester" || userRole == "Tester Account Admin" || userRole == "Tester Data Uploader" || userRole == "Tester Data Uploader & Tester Account Admin") {
            navigate("/dashboard");
          } else if (
            userRole == "Data Uploader" || 
            userRole == "Standard User" || 
            userRole == "Account Admin" ||
            userRole == "Account Admin & Data Uploader"
          ) {
            const subscription = safeJsonParse(localStorage.getItem("is_subscribed"));
            const subscription_data_types = getSubscriptionDataTypes(
              safeJsonParse(localStorage.getItem("subscription_data_types")),
            );

            if (subscription == 1 && subscription_data_types.length > 0) {
              if (userRole == "Account Admin" || userRole == "Account Admin & Data Uploader") {
                navigate("/dashboard");
              } else {
                navigate("/weekly-data");
              }
            } else {
              navigate("/subscriptionplan");
            }
          } 
          else {
            navigate("/subscriptionplan");
          }
        }
      } catch (error) {
        setErrors(error);
      }
    }
  };

  const handlEmailClose = () => {
    setForgotModelShow(false);
    setEmailCorrect(false);
    setSendEmail("");
  };

  const handleEmailSend = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!email || !emailRegex.test(email)) {
      setSendEmail(email);
      setEmailCorrect(true);
      return;
    } else {
      setSendEmail(email);
      setEmailCorrect(false);
    }
  };

  const handleSendEmail = async () => {
    if (emailCorrect) {
      return;
    }

    const userData = {
      email: emailSend,
    };

    const response = await AdminUserService.forgot_password(userData).json();
    if (response.status) {
      swal(response.Message).then((willDelete) => {
        if (willDelete) {
          setForgotModelShow(false);
        }
      });
    }
  };

  const handlTermsClose = () => {
    setTermsModelShow(false);
  };

  return (
    <Fragment>
      <div className="page-wraper">
        <div className="browse-job login-style3">
          <div
            className="bg-img-fix overflow-hidden"
            style={{ background: "#fff url(" + bg6 + ")", height: "100vh" }}
          >
            <div className="row gx-0">
              <div className="col-xl-4 col-lg-5 col-md-6 col-sm-12 vh-100 bg-white ">
                <div
                  id="mCSB_1"
                  className="mCustomScrollBox mCS-light mCSB_vertical mCSB_inside"
                  style={{ maxHeight: "653px" }}
                >
                  <div
                    id="mCSB_1_container"
                    className="mCSB_container"
                    style={{
                      position: "relative",
                      top: "0",
                      left: "0",
                      dir: "ltr",
                    }}
                  >
                    <div className="login-form style-2">
                      <div className="card-body">
                        <div className="logo-header">
                          <Link to={"#"} className="logo">
                            <img
                              src={logo}
                              alt=""
                              className="width-230 light-logo"
                            />
                          </Link>
                          <Link to={"#"} className="logo">
                            <img
                              src={LogoWhite}
                              alt=""
                              className="width-230 dark-logo"
                            />
                          </Link>
                        </div>
                        <div className="nav nav-tabs border-bottom-0">
                          <div className="tab-content w-100" id="nav-tabContent">
                            <div
                              className="tab-pane fade active show"
                              id="nav-personal"
                            >
                              {props.errorMessage && (
                                <div className="bg-red-300 text-red-900 border border-red-900 p-1 my-2">
                                  {props.errorMessage}
                                </div>
                              )}
                              {props.successMessage && (
                                <div className="bg-green-300 text-green-900 border border-green-900 p-1 my-2">
                                  {props.successMessage}
                                </div>
                              )}
                              <form className=" dz-form pb-3" onSubmit={onLogin}>
                                <h3 className="form-title m-t0">
                                  Personal Information
                                </h3>
                                <div className="dz-separator-outer m-b5">
                                  <div className="dz-separator bg-primary style-liner"></div>
                                </div>
                                <p>
                                  Enter your e-mail address and your password.{" "}
                                </p>
                                <p className="text-danger">{errors.message} </p>

                                <div className="form-group mb-3">
                                  <input
                                    type="email"
                                    className="form-control"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="Enter email"
                                  />
                                  {errors.email && (
                                    <div className="text-danger fs-12 mt-2">
                                      {errors.email}
                                    </div>
                                  )}
                                </div>

                                <div className="form-group mb-3 input-group">
                                  <input
                                    type={showPassword ? "text" : "password"}
                                    className="form-control"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    placeholder="Enter password"
                                  />
                                  <button
                                    className="btn btn-outline-light"
                                    type="button"
                                    onClick={() => setShowPassword(!showPassword)}
                                    style={{ borderColor: "#cccccc" }}
                                  >
                                    {showPassword ? <FiEye /> : <FiEyeOff />}
                                  </button>
                                  {errors.password && (
                                    <div className="text-danger fs-12 mt-2">
                                      {errors.password}
                                    </div>
                                  )}
                                </div>

                                {/* Terms & Conditions Section */}
                                <div className="form-group mb-3 text-right">
                                  <div className="form-check d-inline-block mt-2">
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id="check2"
                                      name="terms_accept"
                                      checked={termsSelected}
                                      onChange={handleTermsandConditionsChange}
                                    />
                                    <label className="form-check-label" htmlFor="check2">
                                      I accept the Terms & Conditions
                                    </label>
                                  </div>
                                    {errors.terms_accept && (
                                      <div className="text-danger fs-12 mt-2">
                                        {errors.terms_accept}
                                      </div>
                                    )}

                                  <div className="mt-2">
                                    <span>
                                      By signing in, you agree to our{" "}
                                      <Link className="text-primary" to="/terms">
                                        Terms of Service
                                      </Link>
                                    </span>
                                  </div>
                                </div>

                                {/* Login + Remember Me */}
                                <div className="form-group mb-4 d-flex align-items-center">
                                  <button
                                    type="submit"
                                    className="btn btn-primary"
                                  // disabled={!termsSelected}
                                  >
                                    Login
                                  </button>

                                  <div className="form-check ms-3">
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id="check1"
                                      checked={rememberMe}
                                      onChange={handleRememberMeChange}
                                    />
                                    <label className="form-check-label" htmlFor="check1">
                                      Remember me
                                    </label>
                                  </div>
                                </div>

                                {/* Forgot Password */}
                                <div className="form-group mt-2">
                                  <Link className="text-primary" onClick={() => setForgotModelShow(true)}>
                                    Forgot Password?
                                  </Link>
                                </div>

                                {/* <div className="dz-social">
																<h5 className="form-title fs-20">Sign In With</h5>
																<ul className="dz-social-icon dz-border dz-social-icon-lg text-white">
																	<li><a target="_blank" href="https://www.facebook.com/dexignzone" className="fab fa-facebook-f btn-facebook"></a></li>
																	<li><a target="_blank" href="mailto:dexignzones@gmail.com" className="fab fa-google-plus-g btn-google-plus"></a></li>
																	<li><a target="_blank" href="https://www.linkedin.com/in/dexignzone" className="fab fa-linkedin-in btn-linkedin"></a></li>
																	<li><a target="_blank" href="https://twitter.com/dexignzones" className="fab fa-twitter btn-twitter"></a></li>
																</ul>
															</div> */}
                              </form>
                              <div className="text-center bottom">
                                <NavLink to="/registration" className="btn btn-primary button-md btn-block" >
                                  Create an account
                                </NavLink>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="card-footer">
                        <div className=" bottom-footer clearfix m-t10 m-b20 row text-center">
                          <div className="col-lg-12 text-center">
                            <p>
                              {" "}
                              © {new Date().getFullYear()} Website Developed by{" "}
                              <a
                                href="https://www.rigicglobalsolutions.com/"
                                target="_blank"
                                rel="noreferrer"
                              >
                                Rigic Global Solutions Pvt Ltd
                              </a>{" "}
                              All Rights Reserved
                            </p>{" "}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Reset Password */}
      <Modal show={forgotModelShow} onHide={() => setForgotModelShow(true)}>
        <>
          <Modal.Header>
            <Modal.Title>Forgot Password</Modal.Title>
            <button
              className="btn-close"
              aria-label="Close"
              onClick={() => handlEmailClose()}
            ></button>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group controlId="email">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter your email"
                  value={emailSend}
                  onChange={(e) => handleEmailSend(e.target.value)}
                />
                {emailCorrect && (
                  <div style={{ color: 'red', marginTop: '5px' }}>
                    Please enter a valid email address
                  </div>
                )}
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => handlEmailClose()}>
              Cancel
            </Button>
            <Button variant="primary" onClick={handleSendEmail}>
              Send
            </Button>
          </Modal.Footer>
        </>
      </Modal>

      {/* Terms of service */}
      <Modal size="xl" show={termsModelShow} onHide={() => setTermsModelShow(true)}>
        <>
          <Modal.Header>
            <Modal.Title>Terms of service</Modal.Title>
            <button
              className="btn-close"
              aria-label="Close"
              onClick={() => handlTermsClose()}
            ></button>
          </Modal.Header>
          <Modal.Body>
            <div style={{ whiteSpace: "pre-wrap", maxHeight: "70vh", overflowY: "auto", color: "black" }}>
              <div>Welcome to vegasdata.homes (the "Website"), a website and/or service provided by Homebuilders Research, Inc., a Nevada corporation ("Company," "we," "us," or "our").</div>
              <div className="mt-3">These Terms of Service ("Terms") govern your access to and use of our Website and any information, construction and/or housing industry data, analytics, and other services obtained through the Website and/or purchased from us (collectively, "Services" or the "Service").</div>
              <div className="mt-3"><b>PLEASE READ THESE TERMS CAREFULLY. BY ACCESSING OR USING OUR SERVICE, YOU AGREE TO BE BOUND BY THESE TERMS.  IF YOU DO NOT AGREE TO THESE TERMS, YOU MAY NOT ACCESS OR USE THE SERVICE.</b></div>
              <div className="mt-3">
                <b>1. Acceptance of Terms</b>
                <div className="mt-3">By creating an account, accessing the Website, or using or purchasing any Services, you represent that you have read, understood, and agree to be bound by these Terms. If you are using the Service on behalf of an entity, you represent and warrant that you have the authority to bind that entity to these Terms.</div>
              </div>
              <div className="mt-3">
                <b>2. Description of Services</b>
                <div className="mt-3">The Service provides customers with access to construction and/or housing industry data, including, but not limited to, information regarding permits, closings, buyer traffic, sales, cancellations, pricing data, etc., market trends, and analytics primarily for Clark County, Nevada.</div>
              </div>
              <div className="mt-3">
                <b>3. User Accounts</b>
                <div className="mt-3">To access most features of the Service, you must register for an account. You agree to:</div>
                <div>
                  <ul style={{ listStyleType: "disc", paddingLeft: "20px", marginTop: "15px", display: "block" }}>
                    <li style={{ listStyleType: "disc", color: "black" }}>Provide accurate, current, and complete information during the registration process.</li>
                    <li style={{ listStyleType: "disc", color: "black" }}>Maintain the security of your password and accept all risks of unauthorized access to your account.</li>
                    <li style={{ listStyleType: "disc", color: "black" }}>Promptly notify us if you discover or otherwise suspect any security breaches related to the Service.</li>
                  </ul>
                  <div className="mt-3">You are responsible for all activities that occur under your account.</div>
                </div>
              </div>

              <div className="mt-3">
                <b>4. Fees and Payment</b>
                <div className="mt-3">Access to the Service requires payment of subscription fees. You agree to pay all applicable fees as described on the Website. All fees are non-refundable except as required by law. We reserve the right to change our prices at any time.</div>
              </div>
              <div className="mt-3">
                <b>5. License and Use Restrictions</b>
                <div className="mt-3">Subject to your compliance with these Terms, we grant you a limited, non-exclusive, non-transferable, non-sublicensable license to access and use the Service for your internal business purposes.</div>
                <div className="mt-3">You agree not to:</div>
                <div>
                  <ul style={{ listStyleType: "disc", paddingLeft: "20px", marginTop: "15px", display: "block" }}>
                    <li style={{ listStyleType: "disc", color: "black" }}>Resell, sublicense, or otherwise make the Service or its data available to any third party.</li>
                    <li style={{ listStyleType: "disc", color: "black" }}>Use the Service for any illegal purpose or in violation of any local, state, national, or international law.</li>
                    <li style={{ listStyleType: "disc", color: "black" }}>Scrape, reverse-engineer, decompile, or otherwise attempt to derive the source code or underlying data of the Service.</li>
                    <li style={{ listStyleType: "disc", color: "black" }}>Remove, alter, or obscure any proprietary notices on any portion of the Service.</li>
                  </ul>
                </div>
              </div>
              <div className="mt-3">
                <b>6. <u>Disclaimer of Warranties and Assumption of Risk</u></b>
                <div className="mt-3">THE SERVICE AND THE DATA AND INFORMATION PROVIDED THEREIN ARE PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS, WITHOUT ANY WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED.</div>
                <div className="mt-3">TO THE FULLEST EXTENT PERMITTED BY LAW, THE COMPANY DISCLAIMS ALL WARRANTIES, EXPRESS OR IMPLIED, IN CONNECTION WITH THE SERVICE AND YOUR USE THEREOF, INCLUDING, WITHOUT LIMITATION, THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.</div>
                <div className="mt-3">THE COMPANY MAKES NO WARRANTIES OR REPRESENTATIONS ABOUT THE ACCURACY, COMPLETENESS, RELIABILITY, OR TIMELINESS OF THE SERVICE'S CONTENT. DATA MAY BE INCOMPLETE, INACCURATE, OR OUT OF DATE. YOU ACKNOWLEDGE THAT YOU ARE USING THE SERVICE AND INFORMATION CONTAINED IN CONNECTION THEREWITH AT YOUR OWN RISK.</div>
                <div className="mt-3">YOU AGREE THAT WE HAVE NOT MADE ANY REPRESENTATIONS OR WARRANTIES TO YOU OTHER THAN AS SET FORTH HEREIN AND, AS SUCH, YOU HAVE NOT RELIED ON ANYTHING NOT SET FORTH HEREIN.</div>
                <div className="mt-3">YOU UNDERSTAND, ACKNOWLEDGE AND AGREE THAT ASPECTS OF THE INFORMATION PROVIDED TO YOU IN CONNECTION WITH THE SERVICE ARE OBTAINED FROM THIRD PARTIES AND, AS SUCH, WE ARE UNABLE TO VERIFY THE ACCURACY OF ALL OF THE INFORMATION. WE MAKE NO GUARANTEE OF THE ACCURACY OF THE INFORMATION AND YOU ASSUME ALL RISKS ASSOCIATED WITH YOUR USE OF SUCH INFORMATION.</div>
                <div className="mt-3">Notwithstanding the foregoing, <u>all information provided by our Service is accurate to the best of our knowledge and no information provided is knowingly inaccurate.</u></div>
              </div>
              <div className="mt-3">
                <b>7. Limitation of Liability and Exculpation</b>
                <div className="mt-3">YOU AGREE THAT, TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL THE COMPANY, ITS OFFICERS, DIRECTORS, EMPLOYEES, OR AGENTS, BE LIABLE TO YOU FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, PUNITIVE, OR CONSEQUENTIAL DAMAGES WHATSOEVER RESULTING FROM ANY: (I) ERRORS, MISTAKES, OR INACCURACIES OF CONTENT OR DATA OBTAINED BY YOU IN CONNECTION WITH THE SERVICES; (II) PERSONAL INJURY OR PROPERTY DAMAGE, OF ANY NATURE WHATSOEVER, RESULTING FROM YOUR ACCESS TO AND USE OF OUR SERVICE; (III) ANY UNAUTHORIZED ACCESS TO OR USE OF OUR SECURE SERVERS AND/OR ANY AND ALL PERSONAL INFORMATION STORED THEREIN; (IV) ANY INTERRUPTION OR CESSATION OF TRANSMISSION TO OR FROM OUR SERVICE; (V) ANY BUGS, VIRUSES, TROJAN HORSES, OR THE LIKE WHICH MAY BE TRANSMITTED TO OR THROUGH OUR SERVICE BY ANY THIRD PARTY.</div>
                <div className="mt-3">THE FOREGOING LIMITATION OF LIABILITY SHALL APPLY TO THE FULLEST EXTENT PERMITTED BY LAW AND INCLUDES NEGLIGENCE OF ANY KIND.</div>
                <div className="mt-3">IN NO EVENT SHALL THE COMPANY'S TOTAL AGGREGATE LIABILITY TO YOU FOR ALL DAMAGES, LOSSES, AND CAUSES OF ACTION (WHETHER IN CONTRACT, TORT (INCLUDING NEGLIGENCE), OR OTHERWISE) EXCEED THE AMOUNT YOU HAVE PAID TO THE COMPANY IN THE LAST SIX (6) MONTHS, OR, IF GREATER, ONE HUNDRED DOLLARS ($100).</div>
                <div className="mt-3">YOU AGREE THAT WE HAVE NOT MADE ANY REPRESENTATIONS OR WARRANTIES TO YOU OTHER THAN AS SET FORTH HEREIN AND, AS SUCH, YOU HAVE NOT RELIED ON ANYTHING NOT SET FORTH HEREIN.</div>
                <div className="mt-3">FURTHERMORE, YOU HEREBY KNOWINGLY AND VOLUNTARILY RELEASE AND FOREVER DISCHARGE THE COMPANY, ITS OFFICERS, DIRECTORS, EMPLOYEES, AGENTS, AND SUCCESSORS FROM ANY AND ALL CLAIMS, DEMANDS, LIABILITIES, ACTIONS, CAUSES OF ACTION, AND DAMAGES OF ANY KIND, WHETHER KNOWN OR UNKNOWN, ARISING OUT OF OR IN ANY WAY CONNECTED WITH YOUR USE OF THE SERVICE, <b>CLAIMS FOR NEGLIGENCE.</b></div>
                <div className="mt-3">THE SOLE AND ABSOLUTE EXCEPTION TO THIS RELEASE IS FOR CLAIMS DIRECTLY AND PROXIMATELY CAUSED BY THE INTENTIONAL MISCONDUCT OF THE COMPANY.</div>
              </div>
              <div className="mt-3">
                <b>8. Indemnification</b>
                <div className="mt-3">You agree to defend, indemnify, and hold harmless the Company, its affiliates, and their respective officers, directors, employees, and agents from and against any and all claims, damages, obligations, losses, liabilities, costs, or debt, and expenses (including but not limited to attorney's fees) arising from: (i) your use of and access to the Service; (ii) your violation of any term of these Terms; or (iii) your violation of any third-party right, including without limitation any copyright, property, or privacy right.</div>
              </div>
              <div className="mt-3">
                <b>9. Governing Law and Exclusive Venue</b>
                <div className="mt-3">These Terms shall be governed by and construed in accordance with the laws of the State of Nevada, without regard to its conflict of law principles.</div>
                <div className="mt-3">You agree that any legal action or proceeding arising out of or relating to these Terms or the Service shall be brought exclusively in the state or federal courts located in <b>Clark County, Nevada.</b> You hereby consent to the exclusive jurisdiction and venue of such courts.</div>
              </div>
              <div className="mt-3">
                <b>10. Modifications to Terms</b>
                <div className="mt-3">We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material, we will provide at least 30 days' notice prior to any new terms taking effect. What constitutes a material change will be determined at our sole discretion.</div>
                <div className="mt-3">No medication, amendment or waiver of any provision of these Terms will be effective unless in writing and signed by one of our authorized representatives.</div>
              </div>
              <div className="mt-3">
                <b>11. Complete Agreement</b>
                <div className="mt-3">These Terms shall constitute the entire agreement between you and us concerning the Service. These Terms supersede all prior and contemporaneous agreements, proposals, representations, and understandings, whether oral or written.</div>
              </div>
              <div className="mt-3">
                <b>12. Termination</b>
                <div className="mt-3">We may terminate or suspend your account and bar access to the Service immediately, without prior notice or liability, for your failure to pay amounts due or other breach or violation of these Terms.</div>
              </div>
              <div className="mt-3">
                <b>13. Severability</b>
                <div className="mt-3">I agree that if any portion of these Terms are found to be void or unenforceable, the remaining portions shall remain in full force and effect.</div>
              </div>
              <div className="mt-3">
                <b>14. Contact Information</b>
                <div className="mt-3">If you have any questions about these Terms, please contact us at info@homebuildersresearch.com.</div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            {/* <Button variant="secondary" onClick={() => handlTermsClose()}>
              Cancel
            </Button> */}
            <Button variant="primary" onClick={() => handlTermsClose()}>
              Accept
            </Button>
          </Modal.Footer>
        </>
      </Modal>
      <FloatingSupport inline={true} auth={true} />
    </Fragment>
  );
}

const mapStateToProps = (state) => {
  return {
    errorMessage: state.auth.errorMessage,
    successMessage: state.auth.successMessage,
    showLoading: state.auth.showLoading,
  };
};
export default connect(mapStateToProps)(Login);
